export default {
  beginning: `This is the beginning of your pullup journey!`
};
